export default "__VITE_ASSET__65466596__"